import React, { useState, useEffect, createRef } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { getPutPostConfig } from '../../common/ResourceApi';

import { LoadingAnimation } from '../../common/components/Utilities';

function ObjectiveKeyResults(props) {
  const objectiveId = props.objective;
  const [loading, setLoading] = useState(true);
  const [keyResults, setData] = useState();
  const keyResultRef = createRef();

  const edit = parseInt(props.edit, 10) === 1;

  const loadData = () => {
    setLoading(true);
    axios
      .get(`/key-results?objective_id=${objectiveId}`)
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading('Failed to load key results.');
      });
  };

  const setCompleted = (id, isCompleted) => {
    if (!edit) {
      return;
    }

    setLoading(true);
    axios.post(`/key-results/${id}`, { _method: 'PUT', is_completed: isCompleted }, getPutPostConfig())
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading('Failed to update key result.');
      });
  };

  const deleteKeyResult = (id) => {
    if (window.confirm('Are you sure you want to delete this key result?')) {
      setLoading(true);
      axios.post(`/key-results/${id}`, { _method: 'DELETE' }, getPutPostConfig())
        .then(({ data }) => {
          setData(data);
          setLoading(false);
        })
        .catch(() => {
          setLoading('Failed to delete key result.');
        });
    }
  };

  const addKeyResult = (e) => {
    e.preventDefault();

    setLoading(true);
    axios.post('/key-results', {
      _method: 'POST', is_completed: false, description: keyResultRef.current.value, objective_id: objectiveId,
    }, getPutPostConfig())
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading('Failed to create key result.');
      });
  };

  useEffect(() => {
    if (typeof keyResults === 'undefined') {
      loadData();
    }
  });

  if (typeof keyResults === 'undefined') {
    return (
      <LoadingAnimation loading={loading} />
    );
  }

  let addNew = '';

  if (edit) {
    addNew = (
      <Form onSubmit={addKeyResult}>
        <InputGroup className="mt-4">
          <FormControl type="text" ref={keyResultRef} placeholder="Add a new key result..." required />
          <InputGroup.Append>
            <Button type="submit" variant="outline-success"><i className="fa fa-plus" /></Button>
          </InputGroup.Append>
        </InputGroup>
      </Form>
    );
  }

  return (
    <>
      <LoadingAnimation loading={loading} />
      <table className="table mb-0">
        <tbody>
          {keyResults.map((kr) => (
            <KeyResult
              edit={edit}
              setCompleted={setCompleted}
              deleteKeyResult={deleteKeyResult}
              key={kr.id}
              {...kr}
            />
          ))}
        </tbody>
      </table>

      {addNew}
    </>
  );
}

export function KeyResult(props) {
  return (
    <tr className={(props.is_completed ? 'text-success' : '')}>
      <td className="align-middle" width="1">
        <i role="button" tabIndex={-1} className={`fa fa-lg fa-check btn-unstyled ${props.is_completed ? 'text-success' : 'text-muted'}`} onClick={() => { props.setCompleted(props.id, !props.is_completed); }} />
      </td>
      <th className="align-middle" style={{ fontSize: '1.1em' }}>{props.description}</th>
      <td className="align-middle" width="1">
        <i role="button" tabIndex={-1} style={{ display: (props.edit ? 'inline' : 'none') }} className="fa fa-xs fa-trash text-danger btn-unstyled" onClick={() => { props.deleteKeyResult(props.id); }} />
      </td>
    </tr>
  );
}

export default ObjectiveKeyResults;
